const e = "styles-module__week_container___eJRbn", _ = "styles-module__week_day___Zd0Ih", t = {
  week_container: e,
  week_day: _
};
export {
  t as default,
  e as week_container,
  _ as week_day
};
